export default __webpack_public_path__ + "static/media/errorViewBackground-1400x600.d0b9f94b.webp";